import React from 'react';
import ForesightApp from './ForesightApp';

const App: React.FC = () => {
  // TODO: multi-tenant support will be added later. For now, we are hardcoding the tenant ID to Bazaar.
  // Single-tenant Bazaar application with API-driven data
  return <ForesightApp />;
};

export default App;
